/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const InfoIcon = ({
  className,
  style,
  color = '#3A50F3',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M8 1.03226C11.8265 1.03226 14.9677 4.13145 14.9677 8C14.9677 11.8481 11.8513 14.9677 8 14.9677C4.15342 14.9677 1.03226 11.8528 1.03226 8C1.03226 4.15474 4.14845 1.03226 8 1.03226ZM8 0C3.58203 0 0 3.58332 0 8C0 12.4193 3.58203 16 8 16C12.418 16 16 12.4193 16 8C16 3.58332 12.418 0 8 0ZM6.83871 11.0968H7.22581V7.22581H6.83871C6.62494 7.22581 6.45161 7.05248 6.45161 6.83871V6.58065C6.45161 6.36687 6.62494 6.19355 6.83871 6.19355H8.3871C8.60087 6.19355 8.77419 6.36687 8.77419 6.58065V11.0968H9.16129C9.37506 11.0968 9.54839 11.2701 9.54839 11.4839V11.7419C9.54839 11.9557 9.37506 12.129 9.16129 12.129H6.83871C6.62494 12.129 6.45161 11.9557 6.45161 11.7419V11.4839C6.45161 11.2701 6.62494 11.0968 6.83871 11.0968ZM8 3.35484C7.4299 3.35484 6.96774 3.817 6.96774 4.3871C6.96774 4.95719 7.4299 5.41935 8 5.41935C8.5701 5.41935 9.03226 4.95719 9.03226 4.3871C9.03226 3.817 8.5701 3.35484 8 3.35484Z"
        fill={color}
      />
    </svg>
  );
};
